import { createElement } from 'react';
import { Map, Marker, NavigationControl, ZoomControl, CityListControl } from 'react-bmapgl';
import './index.scss';
const BaiduMaps = function BaiduMaps({ style: styleOption = {}, modelTitle: title = "百度地图", }) {
    return (createElement("div", { style: { heigth: "450px", ...styleOption }, className: "baidu-maps" },
        createElement("div", { className: "maps-title" }, title),
        createElement(Map, { center: { lng: 116.402544, lat: 39.928216 }, zoom: "11" },
            createElement(Marker, { position: { lng: 116.402544, lat: 39.928216 } }),
            createElement(NavigationControl, null),
            createElement(ZoomControl, null),
            createElement(CityListControl, null))));
};
export default BaiduMaps;
